import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'
import { transformResponseParcelDetail } from '@/parcels/transformers/parcels/transformers'
import routes from '@/Router/routes.constants'

const useOpenParcelDetail = ({ storeId, parcels, openParcelDetailDrawerWithId, updateContext }) => {
  const [showParcelDetail, setShowParcelDetail] = useState(false)
  const [parcelDetailSelectedId, setParcelDetailSelectedId] = useState(null)
  const prevParcelDetailSelectedId = useRef(null)
  const navigate = useNavigate()
  const {
    data: parcel,
    fetchData: fetchParcel,
    loading: fetchingParcel,
  } = useFetch(() => parcelServices.getParcel({ parcelId: parcelDetailSelectedId, storeId }), {
    doInitialRequest: false,
    transformResponse: transformResponseParcelDetail,
  })

  useEffect(() => {
    if (openParcelDetailDrawerWithId && parcels?.length) {
      setParcelDetailSelectedId(openParcelDetailDrawerWithId)
      setShowParcelDetail(true)
      updateContext(context => ({
        ...context,
        openParcelDetailDrawerWithId: null,
        returnToParcelsPageAfterPrepare: false,
      }))
    }
  }, [openParcelDetailDrawerWithId, parcels?.length, updateContext])

  useEffect(() => {
    if (parcelDetailSelectedId && parcelDetailSelectedId !== prevParcelDetailSelectedId.current) {
      fetchParcel()
      prevParcelDetailSelectedId.current = parcelDetailSelectedId
    }
  }, [fetchParcel, parcelDetailSelectedId])

  const onOpenParcelDetail = id => {
    setParcelDetailSelectedId(id)
    setShowParcelDetail(true)
  }

  const getParcelDetailHref = id => routes.parcelDetailPage.replace(':id', id)

  const onNavigateToParcelDetail = id => {
    navigate(getParcelDetailHref(id))
  }

  const onParcelDetailClick = (event, id) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return

    event.preventDefault()
    onOpenParcelDetail(id)
  }

  const onCloseParcelDetail = () => {
    setShowParcelDetail(false)
    setParcelDetailSelectedId(null)
  }

  const onNextParcel = () => {
    const index = parcels.findIndex(parcel => parcel.id === parcelDetailSelectedId)

    if (index < parcels.length - 1) {
      onOpenParcelDetail(parcels[index + 1].id)
    }
  }

  const onPrevParcel = () => {
    const index = parcels.findIndex(parcel => parcel.id === parcelDetailSelectedId)

    if (index > 0) {
      onOpenParcelDetail(parcels[index - 1].id)
    }
  }

  return {
    showParcelDetail,
    onOpenParcelDetail,
    onNavigateToParcelDetail,
    getParcelDetailHref,
    onParcelDetailClick,
    onCloseParcelDetail,
    parcelDetailSelectedId,
    parcelDetail: parcel,
    fetchingParcel,
    fetchParcel,
    onNextParcel,
    onPrevParcel,
  }
}

export default useOpenParcelDetail
